import { ImmutableList } from 'src/modules/Immutable';

export type Word = {
  id: string;
  content: string;
  audioUrl: string;
  lemmaWord: string;
  definitions: ImmutableList<string>;
};
